var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DurationDatePicker',{staticClass:"mt-0",attrs:{"placeholder":'選擇',"value":_vm.state}})
}
var staticRenderFns = []

export { render, staticRenderFns }